module.exports = __webpack_public_path__ + "static/media/tty.34a70e93.svg";